import { useState } from 'react';
import { submitFormMutation } from '../../../data-service/forms/functions';

export const CandidateStrategy = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const textFieldChange = ({ name, value }) => {
    if (name === 'name') setName(value);
    if (name === 'email') setEmail(value);
  };

  return (
    <div className="max-w-[680px] py-[40px] lg:py-[80px] mx-auto">
      <h1 className="text-[30px] lg:text-[50px] font-bold text-center">
        Let’s Explore Your Passive Candidate Strategy
      </h1>
      <p className="text-[18px] text-center">
        Curious if this approach would work for your open roles? We’ll walk
        through your current recruitment goals and share what similar hospitals
        are doing to engage passive HCPs more effectively.
      </p>

      <form
        onSubmit={async (e) => {
          e.preventDefault();
          const form = e.currentTarget; // cache before any await
          setLoading(true);
          try {
            const res = await submitFormMutation({
              senderName: name,
              email,
              formName: 'npi-marketing',
              pageUrl: 'hcp-recruitment',
            });

            if (res?.id) {
              setName('');
              setEmail('');
              form.reset(); // now safe
              alert('Thank you for your interest. We will get back to you shortly.');
            }
          } finally {
            setLoading(false);
          }
        }}
      >
        <div
          style={{ boxShadow: '0px 4px 20px -2px #32324714' }}
          className="flex flex-col gap-[20px] p-[20px]"
        >
          <input
            name="name"
            type="text"
            className="border border-[#C0D4EB] p-[10px] rounded-[10px]"
            placeholder="Name"
            value={name}
            onChange={(e) => textFieldChange(e.target)}
            autoComplete="name"
          />

          <input
            name="email"
            type="email"
            required
            className="border border-[#C0D4EB] p-[10px] rounded-[10px]"
            placeholder="Work Email*"
            value={email}
            onChange={(e) => textFieldChange(e.target)}
            autoComplete="email"
          />

          <button type="submit" disabled={loading} className="btn btn-secondary btn-lg">
            Schedule a Strategy Call
          </button>
        </div>
      </form>
    </div>
  );
};
